import React from 'react';
import { useAggregatedAvailability } from './hooks/useAggregatedAvailability';
import type { PMCConfig } from '@kyruus/types';
import { getVisibility } from '../../utils/search-common';
import { AggregatedAvailability } from '@kyruus/scheduling-components';
import { FormattedMessage } from '@kyruus/intl';
import messages from '../messages';
import {
  AppointmentAsideStickyBox,
  AppointmentAsideContainer,
  ScheduleAppointmentTitle
} from './styles';
import { handleAppointmentSlotSelected } from './utils';
export type AppointmentAsideProps = {
  config: PMCConfig;
  primaryLocationId: string;
  customerCode: string;
  productName: string;
};

export const AppointmentAside = ({
  config,
  customerCode,
  productName,
  primaryLocationId
}: AppointmentAsideProps) => {
  const { schedulingVisibility } = getVisibility(config);
  const {
    locationProviders = [],
    locationIds: primaryLocationIds,
    searchClient,
    loading: providersLoading,
    fetchAvailabilitySlots,
    fetchPurposeOptions
  } = useAggregatedAvailability({
    config,
    primaryLocationId,
    customerCode,
    productName,
    schedulingVisibility
  });

  if (providersLoading) {
    return <></>;
  }

  return (
    <AppointmentAsideStickyBox>
      <AppointmentAsideContainer>
        <ScheduleAppointmentTitle
          id="LocationAsideAppointmentTitle"
          data-testid="location-appointment-title"
        >
          <FormattedMessage {...messages.AppointmentTitle} />
        </ScheduleAppointmentTitle>
        <AggregatedAvailability
          config={config}
          customerCode={customerCode}
          providers={locationProviders}
          fetchAvailabilitySlots={fetchAvailabilitySlots}
          fetchPurposeOptions={fetchPurposeOptions}
          locationIds={primaryLocationIds}
          primaryLocationId={primaryLocationId}
          productName={productName}
          handleAppointmentSlotSelected={handleAppointmentSlotSelected}
          searchClient={searchClient}
        />
      </AppointmentAsideContainer>
    </AppointmentAsideStickyBox>
  );
};
